export const checkOverflowRight = (parent: HTMLElement, child: HTMLElement) => {
  const parentRect = parent.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();
  return childRect.right - 10 > parentRect.right;
};

export const checkOverflowLeft = (parent: HTMLElement, child: HTMLElement) => {
  const parentRect = parent.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();
  return childRect.left + 10 < parentRect.left;
};
